import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
